import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Link } from 'react-router-dom';

const MaritimeTransformation = () => {
  return (
    <>
      <Element
      name="MaritimeTransformation"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 col-lg-6 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-left"
                title = "Maritime Industry Transformation"
              />
              <p className="mt-4">Edge AI is redefining how maritime operators respond to real-time challenges-from vessel navigation and energy generation to underwater asset monitoring. Our platform delivers AI-enabled autonomy directly to the edge-onboard ships, buoys, offshore equipment, or subsea nodes.</p>
              <h6 className="mt-5 mb-4">Transformation Highlights</h6>
              <ul>
                <li>From Manual Oversight → To Autonomous Maritime Intelligence</li>
                <li>From Reactive Maintenance → To Predictive Edge Monitoring</li>
                <li>From Centralized Systems → To Localized AI Resilience at Sea</li>
                <li>From Hardware Complexity → To Plug-and-Play Edge Deployments</li>
              </ul>
              <Link className="edu-btn btn-primary" to="/products/m2m-edge-ai">Discover Edge AI Products</Link>
            </div>
            <div className="col-12 col-lg-6 mt-4 mt-md-0 px-0 px-md-4 d-flex flex-row flex-wrap align-items-center justify-content-center">
              <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-blue p-4">
                    <h5 className="mtsc-heading mb-0">
                      +20%
                    </h5>
                    <small>Downtime Reduction</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-green p-4">
                    <h5 className="mtsc-heading mb-0">
                      +30%
                    </h5>
                    <small>Faster Fault Detection</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-purple p-4">
                    <h5 className="mtsc-heading mb-0">
                      +35%
                    </h5>
                    <small>Fuel Consumption Reduction</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-orange p-4">
                    <h5 className="mtsc-heading mb-0">
                      +20%
                    </h5>
                    <small>Energy Output Optimization</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default MaritimeTransformation;